/**
 * AnnotationTitle Component
 * 
 * Renders the title section of a flag annotation timeline item.
 * Displays the annotation type name and an optional duration pill.
 * 
 * @param {Object} annotation - The annotation object containing type, duration, and range info
 */
import React from 'react';
import { Flex, Pill, Text, IconAssignmentLine, IamProtected } from '@smarterservices/smarter-ui';
import { formatDuration } from '../../../helpers/utilities';
import { getStore } from '../../../stores/StoreContext';

const AnnotationTitle = React.memo(({ annotation, onToggleDetailsEdit, isEditingDetails, isHovered }) => {
    let duration;
    let pillColor = "primary";

    const AppStore = getStore('appStore');
    const ExamSessionStore = getStore('examSessionStore');

    if (annotation.duration) {
        duration = formatDuration(annotation.duration);
    }

    if (!annotation.duration && annotation.range.start && !annotation.range.end) {
        duration = 'Ongoing';
        pillColor = "danger";
    }

    if (!duration) {
        return (
            <Flex gap="x-small" alignItems="center">
                <Flex.Item>
                    <span>{annotation.type.name}</span>
                </Flex.Item>
                <Flex.Item shouldGrow shouldShrink>
                    {isHovered && (
                        <div style={{
                            height: '1px',
                            backgroundColor: 'rgba(0, 0, 0, 0.2)',
                            marginLeft: '8px',
                            alignSelf: 'center',
                            animation: 'fadeInLine 0.1s ease-in-out 0.1s both'
                        }} />
                    )}
                </Flex.Item>
            </Flex>
        );
    }

    return (
        <Flex gap="x-small" alignItems="center">
            <Flex.Item>
                <span>{annotation.type.name}</span>
            </Flex.Item>
            <Flex.Item>
                <Pill color={pillColor} margin="none">
                    <Text variant="legend">{duration}</Text>
                </Pill>
            </Flex.Item>
            <Flex.Item shouldGrow shouldShrink>
                {isHovered && (
                    <div style={{
                        height: '1px',
                        backgroundColor: 'rgba(0, 0, 0, 0.2)',
                        marginLeft: '8px',
                        alignSelf: 'center',
                        animation: 'fadeInLine 0.2s ease-in-out 0.1s both'
                    }} />
                )}
            </Flex.Item>
        </Flex>
    );
});

AnnotationTitle.displayName = 'AnnotationTitle';

export default AnnotationTitle;
